export default "__VITE_ASSET__4yjPLZnV__"